import React from 'react';
import { NavLink, Outlet } from 'react-router-dom';

import { CartProvider, useCart } from './CartContext';

const NAV_ITEMS = [
  { to: '/app/marketplace', label: 'Marketplace' },
  { to: '/app/cart', label: 'Cart' },
  { to: '/app/orders', label: 'My orders' },
];

function TabNav() {
  const { totals } = useCart();
  return (
    <nav className="-mb-px flex gap-6 overflow-x-auto whitespace-nowrap border-b border-gray-200">
      {NAV_ITEMS.map((item) => (
        <NavLink
          key={item.to}
          to={item.to}
          end={item.to === '/app/marketplace'}
          className={({ isActive }) =>
            `relative border-b-2 px-1 pb-3 text-sm font-medium transition-colors ${
              isActive
                ? 'border-green-700 text-green-800'
                : 'border-transparent text-gray-500 hover:border-gray-300 hover:text-gray-700'
            }`
          }
        >
          {item.label}
          {item.to === '/app/cart' && totals.itemCount > 0 && (
            <span className="ml-2 inline-flex h-5 min-w-[1.25rem] items-center justify-center rounded-full bg-green-700 px-1.5 text-[10px] font-bold text-white">
              {totals.itemCount}
            </span>
          )}
        </NavLink>
      ))}
    </nav>
  );
}

export default function BuyerLayout() {
  return (
    <CartProvider>
      <div className="flex flex-col gap-6">
        <TabNav />
        <Outlet />
      </div>
    </CartProvider>
  );
}
